import { memo, useMemo } from "react";
import { Flame } from "lucide-react";

function BreakingMarqueeBase({ items }: { items: string[] }) {
  const loop = useMemo(() => (items.length === 0 ? [] : [...items, ...items]), [items]);
  if (loop.length === 0) return null;
  return (
    <div
      className="group relative flex items-center gap-3 overflow-hidden border-b border-white/10 bg-navy py-2 text-primary-foreground"
      style={{ contain: "layout paint", minHeight: 36 }}
    >
      <span className="z-10 flex shrink-0 items-center gap-1.5 bg-primary px-3 py-1 font-condensed text-[0.7rem] font-bold uppercase tracking-[0.25em]">
        <Flame className="h-3 w-3" /> Breaking
      </span>
      <div className="relative flex-1 overflow-hidden">
        <div className="marquee-track flex w-max gap-10 whitespace-nowrap pr-10 font-condensed text-sm font-semibold uppercase tracking-widest text-primary-foreground/85 group-hover:[animation-play-state:paused]">
          {loop.map((t, i) => (
            <span key={i} className="inline-flex items-center gap-3">
              <span className="h-1.5 w-1.5 rounded-full bg-sky" />
              {t}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}


export const BreakingMarquee = memo(
  BreakingMarqueeBase,
  (prev, next) =>
    prev.items.length === next.items.length &&
    prev.items.every((v, i) => v === next.items[i]),
);
